import {
    createVNode as _$cv,
    className as _$cn,
    createElementVNode as _$ce,
    noop as _$no,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Transition} from 'intact';
import {Icon} from '../icon';
import {isInvalid, noop} from 'intact-shared';
import {expandAnimationCallbacks, getRestProps, isEmptyString} from '../utils';
import {makeStyles} from './styles';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {
        hasContentProp,
        isExpanded,
        getRootStyle,
        getTitleText,
        getContentText,
        onToggle,
    } = this.think;
    
    const {
        className, loading, blink, children,
    } = this.get();
    const {k} = this.config;
    const isEmptySlot = (value) => {
        if (isInvalid(value) || isEmptyString(value)) return true;
        if (Array.isArray(value)) return value.every(item => isEmptySlot(item));
        if (value && value.type === 1) return isEmptySlot(value.children);
    
        return false;
    };
    const extraSlot = $blocks.extra ? $blocks.extra(noop) : undefined;
    const contentSlot = $blocks.content ? $blocks.content(noop) : undefined;
    const hasExtraSlot = !isEmptySlot(extraSlot);
    const hasContentSlot = !isEmptySlot(contentSlot);
    const hasContent = hasContentSlot || !!children || hasContentProp();
    const expanded = isExpanded();
    const classNameObj = {
        [`${k}-think`]: true,
        [`${k}-think-expanded`]: expanded,
        [`${k}-think-loading`]: loading,
        [`${k}-think-blink`]: blink,
        [className]: className,
        [makeStyles(k)]: true,
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        'style': getRootStyle(),
        ...getRestProps(this)
    }, [
        _$ce(2, 'button', [
            _$ce(2, 'div', [
                _$ce(2, 'span', (
                    ($blocks.icon) ?
                        (
                            (_$blocks['icon'] = function($super) {
                                return null;
                            }),
                            (__$blocks['icon'] = function($super, data) {
                                var block = $blocks['icon'];
                                var callBlock = function() {
                                    return _$blocks['icon'].call($this, $super, data);
                                };
                                return block ?
                                    block.call($this, callBlock, data) :
                                    callBlock();
                            }),
                            __$blocks['icon'](_$no)
                        ) :
                        _$cc(Icon, {
                            'className': _$cn(loading ? 'ion-load-c' : 'k-icon-think'),
                            'rotate': loading
                        })
                ), 0, _$cn(`${k}-think-icon`)),
                _$ce(2, 'span', (
                    ($blocks.title) ?
                        (
                            (_$blocks['title'] = function($super) {
                                return null;
                            }),
                            (__$blocks['title'] = function($super, data) {
                                var block = $blocks['title'];
                                var callBlock = function() {
                                    return _$blocks['title'].call($this, $super, data);
                                };
                                return block ?
                                    block.call($this, callBlock, data) :
                                    callBlock();
                            }),
                            __$blocks['title'](_$no)
                        ) :
                        _$ce(2, 'span', getTitleText(), 0)
                ), 0, _$cn(`${k}-think-title`))
            ], 4, _$cn(`${k}-think-status-main`)),
            _$ce(2, 'div', [
                (hasExtraSlot) ?
                    _$ce(2, 'div', extraSlot, 0, _$cn(`${k}-think-extra`)) :
                    undefined,
                (hasContent) ?
                    _$cc(Icon, {
                        'className': _$cn(`${k}-think-arrow k-icon-right`)
                    }) :
                    undefined
            ], 0, _$cn(`${k}-think-status-side`))
        ], 4, _$cn(`${k}-think-status`), {
            'type': 'button',
            'ev-click': onToggle
        }),
        (hasContent) ?
            _$cc(Transition, {
                'show': expanded,
                ...expandAnimationCallbacks,
                'onEnter': el => {
                    expandAnimationCallbacks.onEnter(el);
                },
                'onAfterLeave': el => {
                    expandAnimationCallbacks.onAfterLeave(el);
                },
                'children': (
                    _$ce(2, 'div', (
                        _$ce(2, 'div', (
                            (hasContentSlot) ?
                                contentSlot :
                                children ?
                                    children :
                                    _$ce(2, 'div', getContentText(), 0, _$cn(`${k}-think-text`))
                        ), 0, _$cn(`${k}-think-content`))
                    ), 2, _$cn(`${k}-think-wrapper`))
                )
            }) :
            undefined
    ]);
};